import { useEffect, useState } from 'react'

import { createSearchArray } from '../../../../utils/api'
import { getIdwellToIdwellRequestsExtraInfo } from '../../IdwellToIdwell.api'

export function useIdwellToIdwellLoadRequestExtraTableData({
  items,
  outboundCompanyUuid,
}) {
  const [extra, setExtra] = useState(null)

  useEffect(() => {
    if (items && outboundCompanyUuid) {
      const params = createSearchArray('id', items)

      if (Array.from(params).length > 0) {
        getIdwellToIdwellRequestsExtraInfo(outboundCompanyUuid, params).then(
          data => setExtra(data.data)
        )
      }
    }
  }, [items, outboundCompanyUuid])

  return { extra }
}
